<template>
  <div class="signUp">
    <el-form
      class="login-form"
      :model="signUpForm"
      :rules="signUpRules"
      ref="signUpForm"
      label-width="200px"
      label-position="right"
    >
      <h3 class="title">报名</h3>
      <el-row>
        <el-col :span="24">
          <el-form-item label="资质文件: " prop="tenderDocument">
            <el-upload :action="uploadFile()" :on-success="getFilePath">
              <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="">
            <span class="red-text">
              *资料真实性自己负责，请务必如实填写，否则报名无效！！！*</span
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div class="button-container" style="margin: 30px 0">
          <el-checkbox class="protocol" v-model="checked"
            >我已仔细阅读
            <a href="javascript:void(0);" @click="checkProtocol"
              >投标承诺函</a
            ></el-checkbox
          >
        </div>
        <div class="button-container">
          <el-button style="width: 100px; margin-right: 20px" @click="back">
            返回
          </el-button>
          <el-button
            type="primary"
            style="width: 100px"
            :loading="loading"
            @click="signUp"
            >提交</el-button
          >
        </div>
      </el-row>
    </el-form>
    <el-dialog
      title="投标承诺函"
      :visible.sync="protocolDiaView"
      :modal="false"
      center
    >
      <div v-html="'<h2>承诺函内容</h2>'"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmProtocol()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const base = process.env.VUE_APP_BASE_API || ''
import CanvasNest from 'canvas-nest.js';
import { signUp } from '@/api';
import { validateForm, validatePwd } from '@/utils';
export default {
  name: 'login',
  data () {
    return {
      loading: false,
      protocolDiaView: false,
      checked: false,
      second: '', //倒计时
      disabled: false, //是否禁用按钮
      timer: null, //计时器

      signUpForm: {
        noticeId: "",
        projectId: "",
        tenderDocument: "",
        tenderDocumentName: "",
        negotiationDocument: "",
        negotiationDocumentName: "",
        price: ""
      },
      signUpRules: {
        tenderDocument: [
          {
            required: true,
            message: '请上传',
            trigger: 'blur'
          }
        ],
        negotiationDocument: [
          {
            required: true,
            message: '请上传',
            trigger: 'blur'
          },
        ],
        price: [
          {
            required: true,
            message: '请输入报价',
            trigger: 'blur'
          }
        ],
      },
      cn: {},
      fileList: []
    };
  },
  created () {
    this.signUpForm.projectId = this.$route.query.projectId;
    this.signUpForm.noticeId = this.$route.query.noticeId;
  },
  computed: {
  },
  methods: {
    // 报名
    signUp () {
      if (!validateForm(this.$refs['signUpForm'])) {
        return;
      }
      if (!this.checked) {
        this.$message({ type: "warning", message: "请勾选投标承诺函" });
        return;
      }
      var that = this;
      this.$confirm("确认提交吗？", "提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function () {
        that.loading = true;
        let params = {
          supplierId: localStorage.getItem("supplierId"),
          projectId: that.signUpForm.projectId,
          tenderDocument: that.signUpForm.tenderDocument,
          tenderDocumentName: that.signUpForm.tenderDocumentName,
          negotiationDocument: that.signUpForm.negotiationDocument,
          negotiationDocumentName: that.signUpForm.negotiationDocumentName,
          price: that.signUpForm.price
        };
        signUp(params).then(res => {
          if (res.data.success) {
            that.loading = false;
            console.log("6666666666666666666");
            // this.$store.commit('LOGIN_IN', res.data.token);
            that.$router.push('/purchaseManage/tender');
          }
        }).catch(() => {
          that.loading = false;
        });
      });
    },
    back () {
      this.$router.go(-1);
    },
    checkProtocol () {
      this.protocolDiaView = true;
    },
    confirmProtocol () {
      this.protocolDiaView = false;
    },
    uploadFile () {
      return base + "/fishcms/fileMio/uploadPrivate";
    },
    // 获取上传成功后的文件路径
    getFilePath (response) {
      console.log(" 文件上传路径： " + response.data.url);
      this.signUpForm.tenderDocument = response.data.url;
      this.signUpForm.tenderDocumentName = response.data.fileName;
    },
    getFilePath2 (response) {
      console.log(" 文件上传路径： " + response.data.url);
      this.signUpForm.negotiationDocument = response.data.url;
      this.signUpForm.negotiationDocumentName = response.data.fileName;
    },
  },
  mounted () {

  }
};
 /* function checkProtocol(){
console.log("33333@@@@");
};*/
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.signUp {
  padding: 30px 200px;
  .title {
    font-size: 20px;
    letter-spacing: 2px;
    font-weight: 700;
    color: #707070;
    margin: 0px auto 40px auto;
    text-align: center;
  }
  .button-container {
    text-align: center;
  }
  .red-text {
    color: red;
  }
}
</style>
